import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningCircleFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m -0.0039,5.3066406 c 0.414199,0 0.75,0.3357904 0.75,0.75 v 4.2988284 c 0,0.414199 -0.335801,0.75 -0.75,0.75 -0.4142,0 -0.75,-0.335801 -0.75,-0.75 V 8.3066406 c 0,-0.4142096 0.3358,-0.75 0.75,-0.75 z M 12,14.943359 c 0.4142,0 0.75,0.335801 0.75,0.75 v 0.04883 c 0,0.414199 -0.3358,0.749999 -0.75,0.749999 -0.4142,0 -0.75,-0.3358 -0.75,-0.749999 v -0.04883 c 0,-0.414199 0.3358,-0.75 0.75,-0.75 z"
	})]
});
export default SvgWarningCircleFill;
